function detectSharePlatform(anchor, index) {
  const explicit = String(anchor?.dataset?.snippetSharePlatform || '').trim().toLowerCase();
  if (explicit === 'x' || explicit === 'bluesky' || explicit === 'threads') {
    return explicit;
  }

  const label = String(anchor?.textContent || '').trim().toLowerCase();
  if (label === 'x') return 'x';
  if (label.includes('bluesky')) return 'bluesky';
  if (label.includes('thread')) return 'threads';

  const href = String(anchor?.getAttribute('href') || '').toLowerCase();
  if (href.includes('twitter.com') || href.includes('x.com')) return 'x';
  if (href.includes('bsky.app')) return 'bluesky';
  if (href.includes('threads.net')) return 'threads';

  return ['x', 'bluesky', 'threads'][index] || '';
}

function buildPageShareIntents(url, text) {
  const body = `${text}\n\n${url}`;
  return {
    x: `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
    bluesky: `https://bsky.app/intent/compose?text=${encodeURIComponent(body)}`,
    threads: `https://www.threads.net/intent/post?text=${encodeURIComponent(body)}`
  };
}

function resolveShareTitle(trigger) {
  const scopedRoot = trigger.closest('.hero, .post-hero, .resource-hero, .blog-hero, .article-hero');
  const scopedTitle = scopedRoot?.querySelector('h1, .post-hero__title, .page-hero__title');
  if (scopedTitle?.textContent) {
    return scopedTitle.textContent.trim();
  }

  const firstH1 = document.querySelector('h1');
  if (firstH1?.textContent) {
    return firstH1.textContent.trim();
  }

  return String(document.title || '').trim();
}

function toSafeHttpUrl(url) {
  if (!url) return '';
  try {
    const parsed = new URL(url, window.location.href);
    return (parsed.protocol === 'http:' || parsed.protocol === 'https:') ? parsed.href : '';
  } catch {
    return '';
  }
}

// A shareable's own url/title live as data attrs on its .button-group (or,
// depending on the pattern, its .evergreen-shareable ancestor) — see
// evergreen-shareable.twig and getShareableUrlFromElement() in
// evergreen-sidebar.js, which resolves the same attrs for its own share/copy buttons.
function resolveShareableUrl(trigger) {
  const group = trigger.closest('.button-group');
  const shareable = trigger.closest('.evergreen-shareable');
  const raw = group?.dataset.shareableUrl || shareable?.dataset.shareableUrl || '';
  return toSafeHttpUrl(raw.trim()) || window.location.href;
}

function resolveShareableTitle(trigger) {
  const group = trigger.closest('.button-group');
  const shareable = trigger.closest('.evergreen-shareable');
  const title = (group?.dataset.shareableTitle || shareable?.dataset.shareableTitle || '').trim();
  return title || resolveShareTitle(trigger);
}

function hydratePageIntentLinks(panel, url, text) {
  const anchors = Array.from(panel.querySelectorAll('a.social-anchor'));
  if (!anchors.length) return;

  const intents = buildPageShareIntents(url, text);

  anchors.forEach((anchor, index) => {
    const platform = detectSharePlatform(anchor, index);
    const href = intents[platform];
    if (!href) return;

    anchor.href = href;
    anchor.target = '_blank';
    anchor.rel = 'noopener noreferrer';
  });
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-expandable-btn][aria-controls]');
  if (!trigger) return;

  const panelId = trigger.getAttribute('aria-controls');
  if (!panelId) return;

  const panel = document.getElementById(panelId);
  if (!panel) return;

  const mode = panel.getAttribute('data-share-intents');
  if (mode === 'page') {
    hydratePageIntentLinks(panel, window.location.href, resolveShareTitle(trigger));
  } else if (mode === 'shareable') {
    hydratePageIntentLinks(panel, resolveShareableUrl(trigger), resolveShareableTitle(trigger));
  }
});
